<template>
  <span>{{time_format}}</span>
</template>

<script>
export default {
  name: "time_count",
  props: ["time", "index"],
  data() {
    return {
      time_format: ""
    };
  },
  methods: {
    formatTime: function(time) {
      let hours =
        parseInt(time / 60) < 10
          ? "0" + parseInt(time / 60)
          : parseInt(time / 60);
      let second =
        parseInt(time % 60) < 10
          ? "0" + parseInt(time % 60)
          : parseInt(time % 60);
      let time_format = hours + ":" + second;
      return time_format;
    }
  },
  created: function() {
    let self = this;
    let time = self.time;
    let flag = setInterval(function() {
      if (parseInt(time) <= 0) {
        clearInterval(flag);
        self.time_format = self.formatTime(time);
        return self.$emit("time_count_end", self.index);
      }
      self.time_format = self.formatTime(time);
      time--;
    }, 1000);
  }
};
</script>
